import { render, staticRenderFns } from "./InfoUser.vue?vue&type=template&id=617e14b2&scoped=true&"
import script from "./InfoUser.vue?vue&type=script&lang=js&"
export * from "./InfoUser.vue?vue&type=script&lang=js&"
import style0 from "./InfoUser.vue?vue&type=style&index=0&id=617e14b2&lang=scss&scoped=true&"
import style1 from "./InfoUser.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617e14b2",
  null
  
)

export default component.exports